import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleCourseProgressSummaryTableHeadings = [
	{ data: 'status', title: ls('Status') },
	{ data: 'percentComplete', title: ls('% Complete') },
	{
		data: 'avgQuizScore',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsAvgQuizScore, reportingApiSetup.learnDashLabels.quiz)
	},
	{ data: 'certificateLink', title: ls('Certificate Link') },
	{ data: 'courseCompletedDate', title: ls('Completion Date') }
];

const userSingleCourseProgressSummaryTableData = function(courseID, userID) {
	var tableData = [];

	tableData.push({
		status: '',
		percentComplete: '',
		avgQuizScore: '',
		certificateLink: '',
		courseCompletedDate: ''
	});

	return tableData;
};

export {
	userSingleCourseProgressSummaryTableHeadings,
	userSingleCourseProgressSummaryTableData
};
